import { IServiceUrls } from './service-urls.types'

export const SERVICE_URLS_DEV: IServiceUrls = {
  // SHARED
  CINCHCARE_SERVICE_URL: 'https://cinchcare.cnv-dev.aws.cinch.co.uk',
  PERMISSION_URL: 'https://permissions.snc-dev.aws.cinch.co.uk/unsubscribe',
  DELIVERY_SERVICE_URL: 'https://delivery.dev.api.cinch.co.uk',
  ORDER_SERVICE_URL: 'https://orders.dev.api.cinch.co.uk',
  PROFILE_SERVICE_URL: 'https://profile.onr-dev.aws.cinch.co.uk',
  SETTLEMENT_SERVICE_URL: 'https://settlement.dev.api.cinch.co.uk',
  STATIC_ASSETS_URL: 'https://assets-dev.cinch.co.uk',
  IDENTITY_SERVICE_URL: 'https://api-dev.cinch.co.uk/idt/v1',
  AUTH0_SERVICE_URL: 'https://auth-dev.cinch.co.uk',
  CINCH_URL: 'https://cambridge.preview.aws.cinch.co.uk',
  CINCH_APP_URL: 'https://mobile.snc-dev.aws.cinch.co.uk',
  CONSUMER_VALUATIONS_SERVICE_URL:
    'https://consumer-valuations.cnv-dev.aws.cinch.co.uk',
  CINCH_CHARGE_CARD_REQUEST_URL:
    'https://extras-cinch-charge-card.cnv-dev.aws.cinch.co.uk',
  RESERVATION_STATUS_URL:
    'https://orders.dev.api.cinch.co.uk/reservation-status',
  INVENTORY_SERVICE_HISTORY_URL:
    'https://service-history.dev.api.cinch.co.uk/basic',
  IOS_APP_STORE_URL:
    'https://apps.apple.com/gb/app/cinch-cars-without-the-faff/id1641060889',
  ANDROID_APP_STORE_URL:
    'https://play.google.com/store/apps/details?id=com.cinchapp',
  UNSUBSCRIBE_SERVICE_URL:
    'https://communication-v2-user-prefs.dev.api.cinch.co.uk/unsubscribe',
  RESERVATION_SERVICE_URL:
    'https://reservations.cnv-dev.aws.cinch.co.uk/source/orders',
  DELIVERY_SLOT_AVAILABILITY_SERVICE_URL:
    'https://delivery.dev.api.cinch.co.uk/delivery-slots',
  LOGISTICS_FEES_SERVICE_URL: 'https://logistics-fees.snp-dev.aws.cinch.co.uk',
  LOGISTICS_ROUTING_SERVICE_URL:
    'https://logistics-routing.snp-dev.aws.cinch.co.uk',
  LOGISTICS_FULFILMENT_SERVICE_URL:
    'https://logistics-fulfilment.snp-dev.aws.cinch.co.uk',
  FINANCE_APPLICATION_SERVICE_URL:
    'https://finance-application.dev.api.cinch.co.uk',
  FINANCE_OFFER_SERVICE_URL: 'https://finance-offer.dev.api.cinch.co.uk',
  FINANCE_SERVICE_URL: 'https://finance.dev.api.cinch.co.uk',
  FINANCE_QUOTE_SERVICE_URL: 'https://finance-quote.pnf-dev.aws.cinch.co.uk',
  FINANCE_SOFT_SEARCH_URL_PATH: '/finance-eligibility',
  PAYMENT_LINK_SERVICE_URL: 'https://payment-link.cnv-dev.aws.cinch.co.uk',
  GAP_SERVICE_URL: 'https://gap-insurance.cnv-dev.aws.cinch.co.uk',
  CUSTOMER_DATA_API_URL: 'https://customer-data.dev.api.cinch.co.uk',
  VEHICLE_OWNERSHIP_SERVICE_URL:
    'https://vehicle-ownership.onr-dev.aws.cinch.co.uk',
  BANK_SERVICE_URL: 'https://bank-details.cnv-dev.aws.cinch.co.uk',
  HELP_AND_SUPPORT_URL: 'https://help.cinch-dev.co.uk/hc/en-gb/',
  STORE_AVAILABILITY_URL: 'https://store-availability.snp-dev.aws.cinch.co.uk',
  GOOGLE_MAPS_BASE_URL: 'https://maps.googleapis.com/maps/api',
  VEHICLE_PURCHASE_BASE_URL: 'https://vehicle-purchase.cnv-dev.aws.cinch.co.uk',
  SITES_BASE_URL: 'https://sites.service.cinch-dev.co.uk',
  EVOLUTION_IDD_URL:
    'https://www.evolutionfunding.com/public/initial-disclosure-document/',
  MARSHALL_PRIVACY_POLICY_URL:
    'https://www.marshall.co.uk/site/privacy-notice/',
  SANTANDER_PRIVACY_POLICY_URL:
    'https://www.santanderconsumer.co.uk/your-data/privacy-policy/',
  MARSHALL_COMMISSION_STATEMENT_URL:
    'https://www.marshall.co.uk/site/finance-commission-disclosure-statement/',
  NEW_CARS_API_URL: 'new-cars',
  FINANCE_SOFT_SEARCH_URL_V2:
    'https://finance-soft-search.pnf-dev.aws.cinch.co.uk',
  CINCH_SERVICING_URL: 'https://cinch-servicing.onr-dev.aws.cinch.co.uk',
  PROPOSAL_SUBMISSION_URL:
    'https://proposal-submission.pnf-dev.aws.cinch.co.uk',
  IDEAL_POSTCODES_URL: 'https://api.ideal-postcodes.co.uk',
  AWIN_SERVICE_URL: 'https://awin.cnv-dev.aws.cinch.co.uk',
  VEHICLE_ISSUE_TRIAGE_URL:
    'https://zendesk-automations-backend.snc-dev.aws.cinch.co.uk',

  // ACQUISITION AND CONTENT
  TRUSTPILOT_URL: 'https://trustpilot.snc-dev.aws.cinch.co.uk',
  STORYBLOK_BFF_COMPONENT: 'https://storyblok-bff.snc-dev.aws.cinch.co.uk',

  // SEARCH
  SEARCH_SERVICE_URL: 'https://search-api.snc-dev.aws.cinch.co.uk',

  // PRODUCT DETAIL
  PRODUCT_DETAIL_SERVICE_URL: 'https://product.dev.api.cinch.co.uk',
  LEAD_GEN_SERVICE_URL: 'https://cinch-lead-generation.snc-dev.aws.cinch.co.uk',
  VAP_SERVICE_URL: 'https://yybmpue166.execute-api.eu-west-1.amazonaws.com/dev',

  // CONSUMER LENDING
  FEATURE_FLAG_SERVICE_URL: 'https://feature-flag.pnf-dev.aws.cinch.co.uk',
}
